import React, { createContext, useContext, useState, useEffect } from "react";

const SidebarContext = createContext(null);

function getInitialSidebarOpen() {
  if (typeof window === "undefined") return true;
  return !window.matchMedia("(max-width: 1023px)").matches;
}

export function SidebarProvider({ children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(getInitialSidebarOpen);

  useEffect(() => {
    const mql = window.matchMedia("(max-width: 1023px)");
    const handleChange = () => setIsSidebarOpen(!mql.matches);
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const value = {
    isSidebarOpen,
    setSidebarOpen: setIsSidebarOpen,
    toggleSidebar,
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const ctx = useContext(SidebarContext);
  return ctx;
}
